import { AxiosInstance } from "axios";
import { addAuthHeader } from "./request-interceptors";
import { responseErrorHandlerBuilder } from "./response-interceptors";

export const registerInterceptors = (apiInstances: Record<string, AxiosInstance>) => {
  Object.values(apiInstances).forEach((instance) => {
    instance.interceptors.request.use(addAuthHeader);
    instance.interceptors.response.use((response) => response, responseErrorHandlerBuilder(instance));
  });
};
